import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="mt-1 mb-1">
      {vPathName === "/ItemMoqRequest" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Masters{" "}
          </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            MOQ Request{" "}
          </span>
        </div>
      ) : vPathName === "/ItemMoqDetail" ? (
        <div className="d-flex align-items-center">
          {" "}
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Masters{" "}
          </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/ItemMoqRequest"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            MOQ Request
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              MOQ Request Detail
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Breadcrumbs;
